import { resetChartForecastState } from "./chartforecast";
import { resetChartState } from "./chart";
import { resetStoryListState } from "./storylist";


export const resetStoreState = () => async (dispatch: Function, getState : Function) => {
	dispatch(resetChartForecastState());
    dispatch(resetChartState());
    dispatch(resetStoryListState());
};
